import { createIcon } from '@chakra-ui/icons';

export const Bell = createIcon({
  displayName: 'Bell',
  viewBox: '0 0 18 18',
  path: [
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_554_3091)">
        <path
          d="M13.5 6.3253V6.0293C13.5 3.5443 11.485 1.5293 9 1.5293C6.515 1.5293 4.5 3.5443 4.5 6.0293V6.3253C4.5 7.7483 3.743 9.0713 2.508 9.7793C1.867 10.1473 1.5 10.5733 1.5 11.0293C1.5 12.4103 4.858 13.5293 9 13.5293C13.142 13.5293 16.5 12.4103 16.5 11.0293C16.5 10.5733 16.133 10.1473 15.492 9.7793C14.257 9.0723 13.5 7.7483 13.5 6.3253Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.292 15.0293C10.906 15.9123 10.025 16.5293 9.00001 16.5293C7.97501 16.5293 7.09501 15.9123 6.70801 15.0303"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_554_3091">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
